import React from 'react';
import { Link, router } from '@inertiajs/react';
import AuthLayout from './AuthLayout.jsx';

// Chrome for the sales portal. Built on AuthLayout rather than Layout because
// a SalesRep is not a User — Layout's navigation is keyed on auth.user, which
// is nil for the whole of this portal, so it would render the logged-out menu.
export default function SalesLayout({ repName, children }) {
  const logout = (e) => {
    e.preventDefault();
    router.delete('/sales/logout');
  };

  return (
    <AuthLayout>
      <header className="border-b border-gray-200 bg-white">
        <div className="max-w-4xl mx-auto px-6 py-3 flex items-center justify-between gap-4">
          <Link href="/sales" className="text-sm font-bold tracking-tight text-gray-900">
            123CEU <span className="font-normal text-gray-400">Sales</span>
          </Link>

          <nav className="flex items-center gap-4 text-sm">
            <Link href="/sales" className="font-medium text-gray-600 hover:text-gray-900">
              My deals
            </Link>
            <Link
              href="/sales/deals/new"
              className="rounded-lg bg-indigo-600 px-3 py-1.5 font-semibold text-white hover:bg-indigo-700 transition"
            >
              New deal
            </Link>
            {repName && <span className="hidden sm:inline text-gray-400">{repName}</span>}
            <button
              type="button"
              onClick={logout}
              className="font-medium text-gray-500 hover:text-gray-900 cursor-pointer"
            >
              Log out
            </button>
          </nav>
        </div>
      </header>

      {children}
    </AuthLayout>
  );
}
